import { render, staticRenderFns } from "./UiProgressLinear.vue?vue&type=template&id=958c780a"
import script from "./UiProgressLinear.vue?vue&type=script&lang=js"
export * from "./UiProgressLinear.vue?vue&type=script&lang=js"
import style0 from "./UiProgressLinear.vue?vue&type=style&index=0&id=958c780a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports